import { useMemo } from "react";
import _ from "lodash";

import { useShallow } from "zustand/react/shallow";
import useMetadataStore from "@/state/metadata";
import useDashboardStore from "@/state/dashboard";
import ClusterMap from "./ClusterMap";

const Map = ({ tei }) => {
  const { geoJson } = useMetadataStore(
    useShallow((state) => ({ geoJson: state.oupGeoJson }))
  );
  const { additionalState } = useDashboardStore(
    useShallow((state) => ({
      additionalState: state.additionalState,
    }))
  );
  const data = additionalState.dashboard8Data;
  const listTei = useMemo(() => {
    if (!data) return null;
    return tei
      ? data
          .filter((row) => row.tei === tei)
          .map((row) => ({
            trackedEntityInstance: row.tei,
            geometry:
              row.latitude && row.longitude
                ? [row.latitude, row.longitude]
                : null,
          }))
      : [];
  }, [JSON.stringify(data), tei]);

  return (
    <>
      {listTei && geoJson && (
        <ClusterMap
          features={geoJson.features.filter((feature) => {
            return (
              feature.geometry.type !== "Point" &&
              feature.properties.level === "2"
            );
          })}
          markers={
            listTei.length
              ? [
                  ...listTei
                    .map((item) => {
                      if (!item.geometry) return null;
                      return {
                        id: item.trackedEntityInstance,
                        geometry: item.geometry,
                      };
                    })
                    .filter((item) => item),
                ]
              : []
          }
        />
      )}
    </>
  );
};

export default Map;
